import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import logo from "../assests/images/menubar_logo.png";
import "../Styles/MenuBar.css";
import {
  AGENT_LOGIN,
  CLIENT_LOGIN,
  USER_ID,
} from "../utils/store-data-constants";
import { clearAllData, getData } from "../utils/store-data";
import { get_client } from "../api/serverWrapper";
import LogoutModal from "../components/modals/LogoutModal";
import DisableAccountModal from "../components/modals/DisableAccountModal";
import CloseAccountModal from "../components/modals/CloseAccountModal";
import TermsModal from "../components/modals/TermsModal";
import ReportIssueModal from "../components/modals/ReportIssueModal";
import Resetpassword from "./Resetpassword";

export default function MenuBar() {
  const navigate = useNavigate();
  const location = useLocation();
  const settingsRef = useRef(null);

  const [showSettingsMenu, setShowSettingsMenu] = useState(false);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [showDisableModal, setShowDisableModal] = useState(false);
  const [showCloseModal, setShowCloseModal] = useState(false);
  const [showReportModal, setShowReportModal] = useState(false);
  const [showTermsModal, setShowTermsModal] = useState(false);
    const [showResetPassword,setShowResetPassword]=useState(false)

  const [issueText, setIssueText] = useState("");
  const [activeMenu, setActiveMenu] = useState("");
  let [agentLogin, setAgetLogin] = useState(true);
  let [clientLogin, setClintLogin] = useState(false);
  const [clientDetails, setClientDetails] = useState(null);
    const [userId,setUserId]=useState(null)

  useEffect(() => {
    loadInitialData();
  }, []);

  const loadInitialData = async () => {
    try {
      let agentLogin = await getData(AGENT_LOGIN);

      setAgetLogin(agentLogin);

      let cLogin = await getData(CLIENT_LOGIN);
      clientLogin = cLogin;
      setClintLogin(clientLogin);
 const userId = await getData(USER_ID);
    setUserId(userId)
      // if(!agentLogin){
      //   let id = await getData(USER_ID)
      //    let resp = await get_client(id);
      // }
    } catch (error) {
      console.log(error);
    }
  };

  const isActive = (...paths) =>
    paths.some((path) => location.pathname === path);

  const LogOut = async () => {
    await clearAllData();
    navigate("/home");
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (settingsRef.current && !settingsRef.current.contains(event.target)) {
        setShowSettingsMenu(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="">
      <header className="top-header d-flex justify-content-between align-items-center px-4 shadow-sm">
        <img
          src={logo}
          alt="WedLuk Logo"
          className="logos"
          style={{ height: "48px", cursor: "pointer" }}
          onClick={() => navigate("/dashboard")}
        />
        <nav className="nav-menu d-flex gap-4">
          <span
            className={`nav-item ${
              location.pathname === "/dashboard" ? "active" : ""
            }`}
            onClick={() => navigate("/dashboard")}
            style={{ cursor: "pointer" }}
          >
            Home
          </span>

          {agentLogin && (
            <span
              className={`nav-item ${
                location.pathname === "/business" ? "active" : ""
              }`}
              onClick={() => navigate("/business")}
              style={{ cursor: "pointer" }}
            >
              Business
            </span>
          )}

          {clientLogin && (
            <span
              className={`nav-item ${
                location.pathname === "/settings" ? "active" : ""
              }`}
              onClick={() => navigate("/settings")}
              style={{ cursor: "pointer" }}
            >
              My Profile
            </span>
          )}

          <div className="settings-wrapper">
            <span
              className={`nav-item ${showSettingsMenu ? "active" : ""}`}
              onClick={() => setShowSettingsMenu(!showSettingsMenu)}
              style={{ cursor: "pointer" }}
            >
              Settings
            </span>

            {showSettingsMenu && (
              <div className="settings-dropdown" ref={settingsRef}>
                <div
                  className="dropdown-item"
                  onClick={() => {
                    setShowSettingsMenu(false);
                    setShowLogoutModal(true);
                  }}
                >
                  Logout
                </div>

                <div
                  className="dropdown-item"
                  onClick={() => {
                    setShowSettingsMenu(false);
                    setShowTermsModal(true);
                  }}
                >
                  Terms of Service
                </div>

                <div
                  className="dropdown-item"
                  onClick={() => {
                    setShowSettingsMenu(false);
                    setShowDisableModal(true);
                  }}
                >
                  Disable Account
                </div>

                <div
                  className="dropdown-item"
                  onClick={() => {
                    setShowSettingsMenu(false);
                    setShowCloseModal(true);
                  }}
                >
                  Close Account
                </div>

                <div
                  className="dropdown-item"
                  onClick={() => {
                    setShowSettingsMenu(false);
                    setShowReportModal(true);
                  }}
                >
                  Report Issue
                </div>
                  <div
                  className="dropdown-item"
                  onClick={() => {
                    setShowSettingsMenu(false);
                    setShowResetPassword(true);
                  }}
                >
                  Reset Password
                </div>
              </div>
            )}
          </div>
        </nav>
      </header>

      <LogoutModal
        isOpen={showLogoutModal}
        onClose={() => setShowLogoutModal(false)}
        onConfirm={LogOut}
      />

      <DisableAccountModal
        isOpen={showDisableModal}
        onClose={() => setShowDisableModal(false)}
        // onConfirm={() => {}}
      />

      <CloseAccountModal
        isOpen={showCloseModal}
        onClose={() => setShowCloseModal(false)}
        onDisable={() => {
          setShowCloseModal(false);
          setShowDisableModal(true);
        }}
        onDelete={() => {}}
      />

      <ReportIssueModal
        isOpen={showReportModal}
        onClose={() => setShowReportModal(false)}
        onSubmit={(issue) => {
          console.log(issue);
        }}
      />

      <TermsModal
        isOpen={showTermsModal}
        onClose={() => setShowTermsModal(false)}
      />
      <Resetpassword
      visible={showResetPassword}
      onClose={() => setShowResetPassword(false)}
  userId={userId}
      />
    </div>
  );
}
